export abstract class IAuthenticationService {
    public abstract IsUserAdmin():boolean;
    public abstract Authenticate(password:string):Promise<void>;
}

export class FakeAuthenticationService implements IAuthenticationService{
    public Authenticate(password: string): Promise<void> {
        return Promise.resolve();
    }

    public IsUserAdmin(): boolean {
        return true;
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/domain/server/IAuthenticationService.ts